// Password and secret key generation utilities

export const generatePassword = (length = 16) => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  let password = '';
  for (let i = 0; i < length; i++) {
    password += charset[array[i] % charset.length];
  }
  return password;
};

export const generateSecretKey = () => {
  const array = new Uint8Array(64);
  crypto.getRandomValues(array);
  return btoa(String.fromCharCode.apply(null, Array.from(array)));
};

export const generateAppKey = () => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  // Laravel requires APP_KEY in format: base64:<32 random bytes encoded as base64>
  return 'base64:' + btoa(String.fromCharCode.apply(null, Array.from(array)));
};
